import { adminRequest } from './client';

export async function request(path, options = {}) {
  return adminRequest(path, options);
}

export function fetchSegmentTasks(params = {}) {
  const q = new URLSearchParams();
  q.set('page', String(params.page != null ? params.page : 0));
  q.set('size', String(params.size != null ? params.size : 10));
  if (params.email) q.set('email', params.email);
  if (params.taskId) q.set('taskId', params.taskId);
  if (params.status) q.set('status', params.status);
  if (params.sortBy) q.set('sortBy', params.sortBy);
  if (params.sortDir) q.set('sortDir', params.sortDir);
  return request(`/admin/segment-tasks?${q.toString()}`);
}

export function deleteSegmentTasks(taskIds) {
  return request('/admin/segment-tasks', {
    method: 'DELETE',
    body: { taskIds },
  });
}

export function retrySegmentTask(taskId) {
  return request(`/admin/segment-tasks/${taskId}/retry`, { method: 'POST' });
}

export function fetchAdminConfig() {
  return request('/admin/config');
}

export function updateAdminConfig(body) {
  return request('/admin/config', { method: 'PUT', body });
}

export function recheckHighlightAsr() {
  return request('/admin/config/highlight-asr/recheck', { method: 'POST' });
}

export function fetchAdminStats() {
  return request('/admin/stats');
}

export function fetchAdminDashboard(range = '7d') {
  return request(`/admin/dashboard?range=${encodeURIComponent(range)}`);
}

export function fetchOperationLogs(page = 0, size = 20) {
  return request(`/admin/operation-logs?page=${page}&size=${size}`);
}

export function fetchUsers(params = {}) {
  const q = new URLSearchParams();
  q.set('page', String(params.page != null ? params.page : 0));
  q.set('size', String(params.size != null ? params.size : 20));
  if (params.email) q.set('email', params.email);
  if (params.plan) q.set('plan', params.plan);
  if (params.status) q.set('status', params.status);
  if (params.sortBy) q.set('sortBy', params.sortBy);
  if (params.sortDir) q.set('sortDir', params.sortDir);
  return request(`/admin/users?${q.toString()}`);
}

export function updateUser(userId, body) {
  return request(`/admin/users/${userId}`, { method: 'PUT', body });
}

export function fetchQuotaPlans() {
  return request('/admin/quota-plans');
}

export function updateQuotaPlan(planCode, body) {
  return request(`/admin/quota-plans/${planCode}`, { method: 'PUT', body });
}

export function fetchFeedback(params = {}) {
  const q = new URLSearchParams();
  q.set('page', String(params.page != null ? params.page : 0));
  q.set('size', String(params.size != null ? params.size : 20));
  return request(`/admin/feedback?${q.toString()}`);
}

export function fetchFeedbackUnreadCount() {
  return request('/admin/feedback/unread-count');
}

export function markFeedbackRead(id) {
  return request(`/admin/feedback/${encodeURIComponent(id)}/read`, { method: 'POST' });
}

export function markAllFeedbackRead() {
  return request('/admin/feedback/read-all', { method: 'POST' });
}

export function fetchInviteCodes() {
  return request('/admin/invite-codes');
}

export function createInviteCode(body) {
  return request('/admin/invite-codes', { method: 'POST', body });
}

export function updateInviteCode(code, body) {
  return request(`/admin/invite-codes/${encodeURIComponent(code)}`, { method: 'PUT', body });
}

export function fetchLoginLogs(params = {}) {
  const q = new URLSearchParams();
  q.set('page', String(params.page != null ? params.page : 0));
  q.set('size', String(params.size != null ? params.size : 20));
  if (params.ip) q.set('ip', params.ip);
  if (params.success !== undefined && params.success !== null && params.success !== '') {
    q.set('success', String(params.success));
  }
  return request(`/admin/security/login-logs?${q.toString()}`);
}

export function fetchIpBlocks() {
  return request('/admin/security/ip-blocks');
}

export function blockIp(body) {
  return request('/admin/security/ip-blocks', { method: 'POST', body });
}

export function unblockIp(ipAddress) {
  return request(`/admin/security/ip-blocks/${encodeURIComponent(ipAddress)}`, { method: 'DELETE' });
}
